import { getOrigin } from '~shared/utils/host';

export const getDiscordSsoUrl = (redirectPath: string): string => {
	const url = new URL('https://discord.com/api/oauth2/authorize');
	url.searchParams.set('response_type', 'code');
	url.searchParams.set(
		'client_id',
		process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID ?? ''
	);
	url.searchParams.set('scope', 'identify email');

	url.searchParams.set('redirect_uri', `${getOrigin()}${redirectPath}`);
	return url.toString();
};
